import React, { createContext, useContext, useEffect, useState } from 'react'
//import { useLocalStorage } from '@uidotdev/usehooks' //FIXME: https://github.com/uidotdev/usehooks/issues/264
import { tsGetVessel } from '../../../Typescript/API_Response'
import { UseQueryResult } from 'react-query'
import { AxiosResponse } from 'axios'
import { useVesselGet } from '../../../APIs/Hooks/VesselHooks'
import { useParams } from 'react-router-dom'

export enum vesselDialogs {
  DESTROY,
  DESTROY_CONFIRM,
  MOVE,
  MOVE_CONFIRM,
  STATUS,
  STATUS_CONFIRM,
}

interface VesselContextInterface {
  vesselQuery: UseQueryResult<tsGetVessel, AxiosResponse<any, any>>
  fields: VesselViewFields
  setFields: (fields: VesselViewFields | any) => void
  openDialog: vesselDialogs | undefined
  setOpenDialog: (open: vesselDialogs | undefined) => void
}

export interface VesselViewFields {
  vesselID?: string
  vesselLocation?: string
  vesselStatus?: string
  destroy?: any
  holdingID?: number
}
export const VesselContext = createContext<VesselContextInterface>(
  {} as VesselContextInterface,
)
export const useVesselContext = () => useContext(VesselContext)

function VesselModule({ children }: { children: any }) {
  const [fields, setFields] = useState({})
  const { vessel_id, holding_id } = useParams()
  const vesselQuery = useVesselGet(vessel_id, true, holding_id)
  const [openDialog, setOpenDialog] = useState<vesselDialogs | undefined>(
    undefined,
  )
  // Reset values on close
  useEffect(() => {
    if (openDialog === undefined) {
      setFields({})
    }
  }, [openDialog])

  return (
    <VesselContext.Provider
      value={{
        vesselQuery,
        fields,
        setFields,
        openDialog,
        setOpenDialog,
      }}
    >
      {children}
    </VesselContext.Provider>
  )
}

export default VesselModule
